var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"boder-box"},[_c('span',{staticClass:"boder-box-title"},[(_vm.showCheckbox)?_c('el-checkbox',{attrs:{"title":"全/反选"},on:{"change":_vm.checkAllChange}}):_vm._e(),_vm._v(" "+_vm._s(_vm.title)+" ")],1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }